
      <template>
        <svg v-on="$listeners" xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="none" viewBox="0 0 30.25 30.25"><path fill="#1890ff" d="M30.25 5.665v18.391l-7.563 6.194-11.721-4.267v4.23L4.33 21.544l19.34 1.51V6.496Zm-6.447.925L12.951 0v4.324L2.987 7.251 0 11.084v8.705l4.273 1.888v-11.16Z" style="stroke-width:1.88945"/></svg>
      </template>
      <script>
      export default {
        name: 'VueSvg',
      }
      </script>
    